import type {GetFragmentResponse} from '@wix/ambassador-document-management-fragments-v1-fragment-snapshot/types'
import _ from 'lodash'

// Reference for similar mapping for Pages data: bolt-ds-adapter/src/host/dtos.ts
export function mapGetFragmentsDataResponse(response: GetFragmentResponse): GetFragmentResponse {
    return {
        ...response,
        fragment: {
            ...response.fragment,
            content: _.mapValues(response.fragment?.content, namespaceData => {
                return {
                    ...namespaceData,
                    namespaceItems: _.mapValues(namespaceData.namespaceItems, item => {
                        // @ts-ignore
                        if (item.metadata && item.value) {
                            // @ts-ignore
                            item.value.metaData = item.metadata
                            // @ts-ignore
                            delete item.metadata
                        }
                        return item
                    })
                }
            })
        }
    }
}
